import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@eb/eds-modal';

import { FORGOT_PASSWORD_EMAIL_STATUSES } from '../../constants/status';

import ForgotPasswordLink from '../../components/ForgotPasswordLink';
import ForgotPasswordEmailStatus from '../../components/ForgotPasswordEmailStatus';
import ForgotPasswordForm from '../../components/newForms/ForgotPasswordForm';

import './ForgotPasswordModal.scss';

const ForgotPasswordSection = ({
    handleForgotPassword,
    setResetPasswordEmailStatus,
    dataTestId = 'forgot-password-link',
    resetPasswordEmailStatus,
    previousFormEmail,
    clearAuthNotification,
    trackOpenForgotPasswordModal,
    trackCloseForgotPasswordModal,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');

    const _handleForgotPassword = ({ email }) => {
        setForgotPasswordEmail(email);
        handleForgotPassword({ email });
    };

    const _handleCloseModal = () => {
        trackCloseForgotPasswordModal();
        setIsModalOpen(false);
        setResetPasswordEmailStatus('');
    };

    const _handleOpenModal = () => {
        clearAuthNotification();
        trackOpenForgotPasswordModal();
        setIsModalOpen(true);
    };
    let body = (
        <ForgotPasswordForm
            onSubmit={_handleForgotPassword}
            autoFocus={isModalOpen}
            dataTestId={`${dataTestId}-form`}
            isSubmitOngoing={
                resetPasswordEmailStatus ===
                FORGOT_PASSWORD_EMAIL_STATUSES.ongoing
            }
            initialValues={{ email: previousFormEmail }}
        />
    );

    if (resetPasswordEmailStatus === FORGOT_PASSWORD_EMAIL_STATUSES.delivered) {
        body = (
            <ForgotPasswordEmailStatus
                email={forgotPasswordEmail}
                usesNewStyles={true}
            />
        );
    }

    return (
        <div className="forgot-password-modal" data-testid={dataTestId}>
            <ForgotPasswordLink
                onClick={_handleOpenModal}
                dataTestId={`${dataTestId}-link`}
            />

            <Modal
                noMinHeight={true}
                isShown={isModalOpen}
                onClose={_handleCloseModal}
            >
                <div className="eds-l-pad-all-8 eds-align--center">{body}</div>
            </Modal>
        </div>
    );
};

ForgotPasswordSection.propTypes = {
    handleForgotPassword: PropTypes.func,
    setResetPasswordEmailStatus: PropTypes.func,
    dataTestId: PropTypes.string,
    resetPasswordEmailStatus: PropTypes.string,
    // We use the email from the previous form to have it pre-populated
    previousFormEmail: PropTypes.string,
};

export default ForgotPasswordSection;
